import { BrandList, Location, SelectedFilters } from "../types/mapData";

const getOrdinal = (
  location: Location,
  brands: BrandList | null,
  marketingGuideId: number,
) => {
  const ordinal =
    brands?.[location.brand_id]?.tags?.find(
      (tag) => tag?.id === marketingGuideId,
    )?.ordinal ??
    location?.tags?.find((tag) => tag?.id === marketingGuideId)?.ordinal ??
    Infinity;
  return ordinal;
};

export const sortLocations = (
  locations: Location[],
  brands: BrandList | null,
  isMarketingGuide: boolean,
  marketingGuideId: number,
) => {
  if (!Array.isArray(locations)) return [];

  return [...locations].sort((a, b) => {
    if (!isMarketingGuide)
      return (a.distance ?? Infinity) - (b.distance ?? Infinity);
    const aOrdinal = getOrdinal(a, brands, marketingGuideId);
    const bOrdinal = getOrdinal(b, brands, marketingGuideId);

    if (aOrdinal !== bOrdinal) {
      return aOrdinal - bOrdinal;
    }

    return (a.distance ?? Infinity) - (b.distance ?? Infinity);
  });
};

export const filterMarketingGuideLocations = (
  locations: Location[],
  brands: BrandList | null,
  selectedCuisines: SelectedFilters | null,
) => {
  return locations.filter((location) => {
    return (
      location?.tags?.some((tag) =>
        selectedCuisines?.tags?.includes(tag?.id),
      ) ||
      brands?.[location.brand_id]?.tags?.some((tag) =>
        selectedCuisines?.tags?.includes(tag?.id),
      )
    );
  });
};
